import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { STATE_ITEMS } from './state-items/state-items.state';
import { stateReducer } from './state-items/state-items.reducer';
import { StateItemsEffects } from './state-items/state-items.effects';

@NgModule({
  declarations: [],
  imports: [StoreModule.forFeature(STATE_ITEMS, stateReducer), EffectsModule.forFeature([StateItemsEffects]), EffectsModule.forRoot([])],
  exports: [],
  providers: []
})
export class AppStoreModule {}
